

<div class="rent-booking">
  <div class="fil-ariane">
    <!-- <a routerLink="/rent">Home</a> > <a routerLink="/rent/details"  [queryParams]="{ id: car.id }">Location</a> > {{car.make}} {{car.model}} {{car.version}} -->

    <span class="clickable-text" (click)="goToPreviousPage()" > < Retour aux résultats</span> > {{car.make}} {{car.model}} {{car.version}}

  </div>

  <mat-stepper linear #stepper class="rent-booking-stepper">

    <mat-step [stepControl]="bookingDetailsForm.control" [editable]="isEditable">
      <!-- <form [formGroup]="bookingDetailsFormGroup"> -->
      <form #bookingDetailsForm="ngForm" class="booking-details-step">

        <ng-template matStepLabel><h3 class="stepper-title">Détails réservation</h3></ng-template>

        <!-- <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput formControlName="firstCtrl" placeholder="Last name, First name" required>
      </mat-form-field>
      -->
      <div class="image-carousel-small-screen">
        <app-image-carousel
          [showThumbnails]="false">

        </app-image-carousel>
      </div>
      <div class="car-booking">

        <div class="car-details">
          <!--
          <div class = "car-details-image">
            <div class = "image-container">
              <img mat-card-image [src]="(carImage != undefined) ? getCarImage() : 'assets/images/car_image_holder.png'" alt="Car Image">
            </div>
          </div> -->
          <div class="image-carousel-big-screen">
            <app-image-carousel
              [showThumbnails]="false">

            </app-image-carousel>
          </div>

          <div class="car-details-make-model">
            <h2 class="key-info"> {{car.make}} {{car.model}} <span>{{car.version}}</span> </h2>
            <div class="dealer-actions">
              <button mat-button class="simple-button-rent" matTooltipPosition="above" matTooltip="Share"><mat-icon>share</mat-icon></button>
              @if (!isSeller) {
                <button mat-button class="simple-button-rent" matTooltipPosition="above" matTooltip="Favorite" (click)="toggleFavorite();$event.stopPropagation()"><mat-icon>{{car.favorite? "favorite": "favorite_outline"}} </mat-icon></button>
              }
            </div>
          </div>

          <h6 class="car-location">
            <img class="mini-flag" src="assets/images/country-flags/{{car.country}}.png" alt="{{car.country}}">
            &nbsp; {{ car.city }}
          </h6>

          <div class="car-details-data">
            <div class="car-details-data-key">
              <h6><mat-icon class="mat-icon-neutral">mail</mat-icon> Année: <span class="bold"> {{car.year}}</span></h6>
              <h6><mat-icon class="mat-icon-neutral">mail</mat-icon> Carburant: <span class="bold"> {{car.fuel}} </span></h6>
              <h6><mat-icon class="mat-icon-neutral">mail</mat-icon> Boite: <span class="bold"> {{car.gearBox}} </span></h6>
            </div>
            <div class="car-details-data-options">
              <h4>Options</h4>
              <mat-divider></mat-divider>
              @for (ft of car.features; track ft) {
                <h6 class="option"><mat-icon class="mat-icon-neutral">check_circle</mat-icon>{{ft}}</h6>
              }
            </div>
          </div>
          <div class="car-details-seller">
            <h6> Loué par
              <button mat-button matTooltipPosition="above" matTooltip="View dealer details"
                (click)="goToSellerPage(car.providerId);$event.stopPropagation()"
                class="simple-button">
                <mat-icon>{{(car.providerType==DealerType.PROFESSIONAL) ? 'domain' : 'person'}} </mat-icon>

                @if (car.providerType==DealerType.PROFESSIONAL) {
                  <span>
                    {{ car.providerBusinessName }}
                  </span>
                }
                @if (car.providerType!=DealerType.PROFESSIONAL) {
                  <span>
                    {{ car.providerName }}
                  </span>
                }
              </button>
              | &nbsp;
              <span>
                <label>Avis clients: </label>
                @for (r of car.providerRatingsSummary.indicators; track r; let i = $index) {
                  <span>
                    <!--{{currentProvider.ratingsCounts[i]}}
                    <mat-icon *ngIf="r===1">star</mat-icon>
                    <mat-icon *ngIf="r!==1"> {{r===0?'star_outlined':'star_half'}}</mat-icon> -->
                    @if (r===1) {
                      <mat-icon class="seller-icon">star</mat-icon>
                    }
                    @if (r!==1) {
                      <mat-icon class="seller-icon"> {{r===0?'star_outlined':'star_half'}}</mat-icon>
                    }
                  </span>
                }
                <b>{{ car.providerRatingsSummary.average.toFixed(2)}} </b>

                <mat-icon class="seller-icon" (click)="showRatingDetails = !showRatingDetails; $event.stopPropagation()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">info</mat-icon>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="trigger"
                  [cdkConnectedOverlayOpen]="showRatingDetails">

                  <div class="ratings-details">
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon>({{car.providerRatingsSummary.counts[4]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[3]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[2]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[1]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[0]}})</h6>
                  </div>
                </ng-template>

                ({{ getSellerRatingsTotalCount()}} avis)
              </span>
            </h6>
          </div>

        </div>

        <div class="booking-details">
          <div class="booking-details-data">
            <div>
              <h6>A partir de</h6>
              <h3 class="key-info">{{moneyFormat(""+car.rentDayRate.amount)}} <span class="price-currency">{{car.rentDayRate.currency}} / jour </span></h3>
            </div>

            <div>
              <h5>Dates</h5>
              <mat-form-field>
                <!-- <mat-label> Dates </mat-label> -->
                <mat-date-range-input matInput [rangePicker]="picker2" [dateFilter]="filterPastDatesAndBookedDates" >
                  <input required matStartDate placeholder="Début" name="start" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="currentBooking.startDate" >
                  <input required matEndDate placeholder="Fin" name="end" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="currentBooking.endDate" >
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-date-range-picker #picker2></mat-date-range-picker>
              </mat-form-field>
            </div>

            <!--
            <button matButton class="cta-button" mat-button
              (click)="showBookingAddNew = !showBookingAddNew;"
              cdkOverlayOrigin #trigger="cdkOverlayOrigin">Ajouter<mat-icon>add</mat-icon>
            </button>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayOpen]="showBookingAddNew">

              <div class="overlay-box">

                <mat-calendar
                  [dateFilter]="filterPastDatesAndBookedDates"
                  [selected]="selectedDateRange"
                  (selectedChange)="onSelectedDateRangeChange($event!)"
                  [dateClass]="dateClass">
                </mat-calendar>
                <button matButton class="simple-button"  mat-button (click)="showBookingAddNew = !showBookingAddNew; " ><b> Fermer </b><mat-icon>close</mat-icon></button>
                <button matButton class="simple-button"  mat-button (click)="addNewBooking();"><b> Reserver </b><mat-icon>save</mat-icon></button>

              </div>
            </ng-template> -->


            <div class="booking-details-data-item">
              <h5>Distance à parcourir</h5>
              <mat-radio-group name="mileageOption" (selectionChange)="onMileageOptionChange()" [(ngModel)]="currentBooking.mileageOption" required>
                @for (option of mileageOptionsList; track option) {
                  <mat-radio-button [value]="option.code">{{ option.desc }}</mat-radio-button>
                }
              </mat-radio-group>
            </div>
            <div>
              <h5>Assurance</h5>
              <mat-radio-group name="insuranceOption" (selectionChange)="onInsuranceOptionChange()" [(ngModel)]="currentBooking.insuranceOption" required>
                @for (option of insuranceOptionsList; track option) {
                  <mat-radio-button [value]="option.code">{{ option.desc }}</mat-radio-button>
                }
              </mat-radio-group>
            </div>

            <h5>Vous conduirez vous meme ?
              &nbsp;
              <mat-slide-toggle
                class="example-margin"
                name = "customerDriving"
                [disabled]="false"
                [(ngModel)]="currentBooking.customerDriving"
                (change)="onCustomerDrivingChange() ">

              </mat-slide-toggle>
            </h5>

            @if (!currentBooking.customerDriving) {
              <h5>Location avec Chauffeur ?
                &nbsp;
                <mat-slide-toggle
                  class="example-margin"
                  name = "withDriver"
                  [disabled]="false"
                  [(ngModel)]="currentBooking.withDriver"
                  (change)="onWithDriverChange() ">
                </mat-slide-toggle>
              </h5>
            }
            <!--
            <mat-checkbox name="withDriver"  class="example-margin" [(ngModel)]="currentBooking.withDriver">Avec chauffeur</mat-checkbox>
            -->

          </div>


          <div class="summary-section">
            <div class="booking-detail-item"><h6>Véhicule ({{currentBooking.getTotalDuration()}} x {{car.rentDayRate.amount }} {{car.rentDayRate.currency}}/J)</h6> <h6><b>{{moneyFormat(""+calculateCarAmount())}} {{currentBooking.currency}}</b></h6></div>
            <div class="booking-detail-item"><h6>Assurance ({{currentBooking.getTotalDuration()}} x {{car.rentInsuranceDayRate.amount}} {{car.rentInsuranceDayRate.currency}}/J)</h6> <h6><b>{{moneyFormat(""+calculateInsuranceAmount())}} {{currentBooking.currency}}</b></h6></div>
            @if (currentBooking.withDriver) {
              <div class="booking-detail-item"><h6>Chauffeur ({{currentBooking.getTotalDuration()}} x {{car.rentDriverDayRate.amount}} {{car.rentDriverDayRate.currency}}/J)</h6> <h6><b>{{moneyFormat(""+calculateDriverAmount())}} {{currentBooking.currency}} </b></h6></div>
            }
            <mat-divider></mat-divider>
            <div class="booking-detail-item"><h5>Total</h5> <h5>{{moneyFormat(""+calculateTotalAmount())}} {{currentBooking.currency}}</h5></div>
          </div>

          <button mat-button class="cta-button-rent" mat-button matStepperNext> Continuer <mat-icon>navigate_next</mat-icon></button>

        </div>

        <!--
        <div class="booking-details-summary">

          <h5>Voiture: </h5>
          <h6>
            {{car.make }} {{car.model }}, {{car.year}}
            <br /> Prix journalier: {{moneyFormat(""+car.rentPrice.amount)}} {{car.rentPrice.currency}} / jour
          </h6>
          <br />
          <h5>Location: </h5>
          <h6>
            Du {{ dateFormat(currentBooking.startDate)}} au {{dateFormat(currentBooking.endDate)}} ({{ currentBooking.getTotalDuration() }} jours)
            <br /> Distance {{currentBooking.mileageOption}}
            <br /> Assurance {{currentBooking.insuranceOption}} ({{moneyFormat(""+insuranceDayRate)}} {{currentBooking.currency}} / jour)
            <br /> {{currentBooking.withDriver ? 'AVEC ': 'SANS '}} chauffeur <span *ngIf="currentBooking.withDriver">({{moneyFormat(""+driverDayRate)}} {{currentBooking.currency}} / jour)</span>
            <br />
            <br /> Véhicule: {{moneyFormat(""+calculateCarAmount())}} {{currentBooking.currency}}
            <br /> Assurance : {{moneyFormat(""+calculateInsuranceAmount())}} {{currentBooking.currency}}
            <span *ngIf="currentBooking.withDriver"> <br />  Chauffeur: {{moneyFormat(""+calculateDriverAmount())}} {{currentBooking.currency}} </span>
            <br /><br /> <b>Montant total: {{moneyFormat(""+calculateTotalAmount())}} {{currentBooking.currency}} </b>
          </h6>
          <br />
          <div>
            <button class="cta-button" mat-button matStepperNext>Confirmer <mat-icon>navigate_next</mat-icon></button>
          </div>
        </div>
        -->
      </div>
    </form>
  </mat-step>
  <!--
  <mat-step [stepControl]="bookingConfirmFormGroup" [editable]="isEditable">
    <form [formGroup]="bookingConfirmFormGroup">

      <ng-template matStepLabel>Fill out your address</ng-template>

      <mat-form-field>
        <mat-label>Address</mat-label>
        <input matInput formControlName="confirmCtrl" placeholder="Ex. 1 Main St, New York, NY"
          required>
        </mat-form-field>

        <div>
          <button mat-button matStepperPrevious>Précédent<mat-icon>navigate_before</mat-icon></button>
          <button mat-button matStepperNext>Suivant<mat-icon>navigate_next</mat-icon></button>
        </div>

      </form>
    </mat-step> -->

    <mat-step [stepControl]="paymentForm.control" [editable]="isEditable">

      <ng-template matStepLabel><h3 class="stepper-title">Confirmer</h3></ng-template>

      <div class="booking-confirm-step">

        <div class="booking-details-summary">

          <h3>Résumé </h3>

          <h5>Véhicule </h5>

          <div class="booking-detail-item"> <h6> Référence</h6> <h6> <b>{{car.make }} {{car.model }}, {{car.year}} </b></h6> </div>
          <div class="booking-detail-item"> <h6> Features</h6> <h6> <b>@for (ft of car.features; track ft) {
          <span> {{ft}} </span>
        } </b></h6> </div>
        <div class="booking-detail-item"> <h6> Prix journalier</h6> <h6> <b>{{moneyFormat(""+car.rentDayRate.amount)}} {{car.rentDayRate.currency}}/jour </b> </h6> </div>
        <mat-divider></mat-divider>

        <h5>Location </h5>
        <div class="booking-detail-item"> <h6> Dates</h6> <h6> <b>{{ dateFormat(currentBooking.startDate)}} - {{dateFormat(currentBooking.endDate)}} </b></h6> </div>
        <div class="booking-detail-item"> <h6> Durée</h6> <h6> <b>{{ currentBooking.getTotalDuration() }} jours </b></h6> </div>
        <div class="booking-detail-item"> <h6> Distance</h6> <h6> <b>{{currentBooking.mileageOption}} </b></h6> </div>
        <div class="booking-detail-item"> <h6> Assurance</h6> <h6> <b>{{currentBooking.insuranceOption}} ({{moneyFormat(""+currentBooking.insuranceDayRate)}} {{currentBooking.currency}}/jour)</b></h6> </div>
        <div class="booking-detail-item"> <h6> <b>{{currentBooking.withDriver ? 'AVEC ': 'SANS '}} </b>chauffeur @if (currentBooking.withDriver) {
        <span>({{moneyFormat(""+currentBooking.driverDayRate)}} {{currentBooking.currency}} / jour)</span>
      }</h6> </div>

      <mat-divider></mat-divider>

      <div class="booking-detail-item"><h6>Véhicule</h6> <h6><b>{{moneyFormat(""+calculateCarAmount())}} {{currentBooking.currency}}</b></h6></div>
      <div class="booking-detail-item"><h6>Assurance</h6> <h6><b>{{moneyFormat(""+calculateInsuranceAmount())}} {{currentBooking.currency}}</b></h6></div>
      @if (currentBooking.withDriver) {
        <div class="booking-detail-item"><h6>Chauffeur</h6> <h6><b>{{moneyFormat(""+calculateDriverAmount())}} {{currentBooking.currency}} </b></h6></div>
      }

      <mat-divider></mat-divider>

      <div class="booking-detail-item"><h3>Total</h3> <h3>{{moneyFormat(""+calculateTotalAmount())}} {{currentBooking.currency}}</h3></div>

      <div>
        <!-- <button mat-button matStepperPrevious>Précédent<mat-icon>navigate_before</mat-icon></button> -->
        <!-- <button class="cta-button" mat-button (click)="confirmBookingSubmit()"
        [disabled]=" !driverInfosForm.valid || driverInfosForm.value.driverPhoneCode == 0 || !paymentForm.valid || paymentForm.value.mobileMoneyPhoneCode == 0 ">
        Payer et Réserver<mat-icon>save</mat-icon>
      </button> -->
      <!-- <button mat-button (click)="stepper.reset()">Annuler<mat-icon>restart_alt</mat-icon></button> -->

    </div>
  </div>

  <div class="booking-confirm">

    <h3>Options de paiement</h3>
    <div class="payment-options">
      @for (option of paymentTermOptions; track option; let i = $index) {
        <div class="payment-option"
          [style.border-color]=" (i===currentPaymentTermOptionIndex) ? 'var(--ctaButtonColor)': '#eee'"
          [style.border-width]=" (i===currentPaymentTermOptionIndex) ? '6px': '4px'"
          (click)="updateCurrentPaymentTermOption(i)">
          <h5>{{option.title}} </h5>
          <h6>{{option.details}} </h6>
          <!-- <h4>{{option.desc}} </h4> -->
        </div>
      }
    </div>

    <!-- <div class="payment-options">
    <div class="payment-option">
      {{PaymentOption.PAY_ADVANCE}}

    </div>
  </div> -->


  <h3>Informations sur le conducteur</h3>

  <form #driverInfosForm = "ngForm" class="booking-driver-infos" >

    @if (currentBooking.customerDriving) {
      <h6>
        Vous conduirez vous meme
      </h6>
    }

    @if (currentBooking.withDriver) {
      <h6>
        Nous vous fournirons un chauffeur
      </h6>
    }

    @if (!currentBooking.customerDriving && !currentBooking.withDriver) {
      <span>
        <!-- <ng-template matStepLabel>Fill out your address</ng-template> -->
        <div class="driver-info-section">
          <!-- <mat-form-field>
          <mat-label>Entreprise</mat-label>
          <input matInput name="driverCompany" placeholder="Entreprise" [(ngModel)]="currentBooking.driverCompany">
        </mat-form-field>
        -->
        <mat-form-field>
          <mat-label>Prénom</mat-label>
          <input  matInput name="driverFname" placeholder="Prénom" [(ngModel)]="currentBooking.driverFirstName">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nom</mat-label>
          <input  matInput name="driverLname" placeholder="Nom"  [(ngModel)]="currentBooking.driverLastName">
        </mat-form-field>
      </div>
      <div class="driver-info-section">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input  matInput name="driverEmail" placeholder="Adresse email"  [(ngModel)]="currentBooking.driverEmail">
        </mat-form-field>
        <div class="phone-number">
          <mat-form-field >
            <mat-label>Pays</mat-label>
            <mat-select  matNativeControl name = "driverPhoneCode" [(ngModel)]="currentBooking.driverPhoneNumber.code">
              @for (country of countries; track country) {
                <mat-option [value]="country.phoneCode"> {{country.name}} +{{country.phoneCode}} </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field >
            <mat-label>Numéro de téléphone</mat-label>
            <input required type="number" matInput="" [pattern]="phoneNumberRegex"  name ="phoneNumber"  [(ngModel)]="currentBooking.driverPhoneNumber" #phoneNumber="ngModel">
            @if (phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)) {
              <span class="error-alert">
                @if (phoneNumber.errors?.['required']) {
                  <span>
                    Le numéro est requis.
                  </span>
                }
                @if (phoneNumber.errors?.['pattern']) {
                  <span>
                    Numéro non valide
                  </span>
                }
              </span>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="driver-info-section">
        <mat-form-field>
          <mat-label>Age</mat-label>
          <mat-select required matNativeControl name="driverAge"  [(ngModel)]="currentBooking.driverAgeMin" >
            <mat-option [value]=20>20 à 24 ans</mat-option>
            <mat-option [value]=25>25 à 29 ans</mat-option>
            <mat-option [value]=30>30 à 39 ans</mat-option>
            <mat-option [value]=40>40 à 49 ans</mat-option>
            <mat-option [value]=50>50 à 64 ans</mat-option>
            <mat-option [value]=65>65 ans et +</mat-option>
          </mat-select >
        </mat-form-field>
      </div>
      <!-- <div>
      <button mat-button matStepperPrevious>Précédent<mat-icon>navigate_before</mat-icon></button>
      <button class="cta-button" mat-button (click)="confirmBookingSubmit()">Réserver<mat-icon>save</mat-icon></button>
      <button mat-button (click)="stepper.reset()">Annuler<mat-icon>restart_alt</mat-icon></button>
    </div>
    -->
  </span>
}
</form>


<h3>Paiement</h3>

<form #paymentForm = "ngForm">

  <!-- <ng-template matStepLabel>Fill out your address</ng-template> -->
  <h6>Montant à payer: <b> {{moneyFormat(""+calculateAmountToPay())}} {{car.rentDayRate.currency}}</b></h6>
  <br />
  <div class="driver-info-section">

    <mat-form-field >
      <mat-label>Opérateur</mat-label>
      <mat-select required matNativeControl name="mobileMoneyOperator" [(ngModel)]="currentBooking.initialPayment.mobileMoneyOperator">
        @for (operator of mobileMoneyOperators; track operator) {
          <mat-option [value]="operator.code"> {{operator.desc}}  </mat-option>
        }
      </mat-select>
    </mat-form-field>


    <div class="phone-number">
      <mat-form-field >
        <mat-label>Pays</mat-label>
        <mat-select required matNativeControl name = "mobileMoneyPhoneCode" [(ngModel)]="currentBooking.initialPayment.mobileMoneyPhoneCode">
          @for (country of countries; track country) {
            <mat-option [value]="country.phoneCode"> {{country.name}} +{{country.phoneCode}} </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field >
        <mat-label>Numéro Mobile Money</mat-label>
        <input required type="number" matInput="" [pattern]="phoneNumberRegex"  name ="mobileMoneyPhoneNumber"  [(ngModel)]="currentBooking.initialPayment.mobileMoneyPhoneNumber" #mobileMoneyPhoneNumber="ngModel">

        @if (mobileMoneyPhoneNumber.invalid && (mobileMoneyPhoneNumber.dirty || mobileMoneyPhoneNumber.touched)) {
          <span class="error-alert">
            @if (mobileMoneyPhoneNumber.errors?.['required']) {
              <span>
                Le numéro est requis.
              </span>
            }
            @if (mobileMoneyPhoneNumber.errors?.['pattern']) {
              <span>
                Numéro non valide
              </span>
            }
          </span>
        }
      </mat-form-field>
    </div>

  </div>
</form>

<div class="cta-buttons">
  <button mat-button class="simple-button-rent" matStepperPrevious>Précédent<mat-icon>navigate_before</mat-icon></button>
  <button class="cta-button-rent" mat-button (click)="confirmBookingSubmit()"
    [disabled]=" !driverInfosForm.valid || driverInfosForm.value.driverPhoneCode == 0 || !paymentForm.valid || paymentForm.value.mobileMoneyPhoneCode == 0 ">
    Payer et Réserver<mat-icon>save</mat-icon>
  </button>
</div>

</div>
</div>
</mat-step>
</mat-stepper>

<div class="similar-cars">
  <h3>Véhicules similaires ({{  (similarCarBriefs$ | async)!.length }})</h3>
  <app-car-box-list
    [businessLine]= businessLine!
    [carBriefs]="similarCarBriefs" >
    <!-- [favorites]="(currentUserFavorites$ | async)!"
    [carImageDatas]="(carImagesFolder != undefined)?carImagesFolder![0]:defaultImageDatas"> -->
  </app-car-box-list>
</div>

<div class="same-seller-cars">
  <h3>Véhicules du meme vendeur ({{  (sameSellerCarBriefs$ | async)!.length }})</h3>
  <app-car-box-list
    [businessLine]= businessLine!
    [carBriefs]="sameSellerCarBriefs">
    <!-- [favorites]="(currentUserFavorites$ | async)!"
    [carImageDatas]="(carImagesFolder != undefined)?carImagesFolder![0]:defaultImageDatas"> -->
  </app-car-box-list>
</div>
</div>